export {default} from './Wrapper';
export * from './types';



// WEBPACK FOOTER //
// ./src/components/Layout/Wrapper/index.ts